import { ServicesServicesServiceProps } from '@services/requests/servicesService/servicesServicesService/interface';
import ServicesServicesService from '@services/requests/servicesService/servicesServicesService/ServicesDirectoriesService';

// Фабрика сервиса дополнительных услуг
export const servicesServicesService: { (token?: string): ServicesServicesServiceProps } = (
  token
) => new ServicesServicesService(token);
